import { AnswersEndpoints, answersFetch } from './answersApiClient';
import { normalizeDocHint, normalizeSerffId } from './answersDocumentService';

const postResolveCitation = (body) => answersFetch(AnswersEndpoints.RESOLVE_CITATION, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(body),
});

/**
 * Resolve an inline citation to full source metadata for PDF preview.
 * Retries without file_name_hint when the hint is too strict (common 404 cause).
 * @param {{ serff_id: string, page_start: number, page_end: number, file_name_hint?: string }} params
 * @returns {Promise<Record<string, unknown> | null>}
 */
export async function resolveCitation(params) {
  const base = {
    serff_id: normalizeSerffId(params.serff_id),
    page_start: params.page_start,
    page_end: params.page_end,
  };
  const hint = normalizeDocHint(params.file_name_hint);
  const withHint = hint ? { ...base, file_name_hint: hint } : base;

  let res = await postResolveCitation(withHint);
  if (res.status === 404 && hint) {
    res = await postResolveCitation(base);
  }
  if (!res.ok) return null;
  return res.json();
}
